<div class="card rounded-left rounded-right" [style.height.px]="cardheight">
  <div class="card-body p-0">
    <img *ngIf="card.imageUrl" class="card-img-top card-img-bottom h-auto d-inline-block" src="{{ card.imageUrl }}"
      alt="Card image cap" />
      <div class="position-absolute bottom-0 start-50 translate-middle-x py-3">
      <!-- <app-oval-button [label]="label" [css]="selectedButton"></app-oval-button> -->
    </div>
  </div>
</div>
